const PREFIX = 'banner-pref:';

function key(name) {
    return `${PREFIX}${name}`;
}

export function setDismissed(name, hours = 24) {
    try {
        const until = new Date();
        until.setHours(until.getHours() + hours);
        localStorage.setItem(key(name), until.toISOString());
    } catch { }
}

export function isDismissed(name) {
    try {
        const value = localStorage.getItem(key(name));
        if (!value) return false;
        const until = new Date(value).getTime();
        return Date.now() < until;
    } catch {
        return false;
    }
}

export function clearDismissal(name) {
    try {
        localStorage.removeItem(key(name));
    } catch { }
}

export default { setDismissed, isDismissed, clearDismissal };


